export default __webpack_public_path__ + "static/media/inbox.6d25d742.svg";